"use client";
const LandingPageFooter = ({
    isDark = false
}) => {
    return (
        <>

            <footer className={`border-t ${isDark ? "border-white/10" : "border-slate-200/60"
                }`}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center space-y-3">

                    <nav aria-label="Footer Navigation" className="text-sm text-slate-600 dark:text-slate-400">
                        <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2">
                            <li><a href="/privacy-policy" className="hover:text-indigo-600 dark:hover:text-indigo-400">Terms &amp; Privacy </a></li>
                            <li><a href="/policies" className="hover:text-indigo-600 dark:hover:text-indigo-400">|</a></li>
                            <li><a href="/" className="hover:text-indigo-600 dark:hover:text-indigo-400">Greeting Cards  </a></li>
                            <li><a href="/policies" className="hover:text-indigo-600 dark:hover:text-indigo-400">|</a></li>
                            <li><a href="/blog" className="hover:text-indigo-600 dark:hover:text-indigo-400">Blog</a></li>
                        </ul>
                    </nav>

                    <div className="text-xs sm:text-sm text-slate-500 dark:text-slate-400 mt-2">
                        Created with <span className={isDark ? "text-white" : "text-slate-500"}>Varnz Page Builder</span>
                    </div>
                    <div className="text-xs sm:text-sm text-slate-500 dark:text-slate-400 mt-2">
                        Powered by <span className={isDark ? "text-white" : "text-slate-500"}>Varnz Labs</span>
                    </div>
                    <div className="text-xs sm:text-sm text-slate-500 dark:text-slate-400 mt-2">
                        © 2025 Varnz. All rights reserved.
                    </div>

                </div>
            </footer>

        </>
    )
}

export default LandingPageFooter